// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sgwqrcujqguximtbtjys.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNnd3FyY3VqcWd1eGltdGJ0anlzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ3MjY2NDEsImV4cCI6MjA1MDMwMjY0MX0.Kebj8rv9IppBzuiAQ2zqZsQR7rDDQVUCchF90Cld8FM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);